var _defs, _path, _path2, _g, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 900,
    height: 600,
    viewBox: "0 0 90 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h90v60H0z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#003580",
    d: "M0 60V0h90z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#009543",
    d: "M90 0v60H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 20,
    d: "M0 60 90 0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#d21034",
    strokeWidth: 15,
    d: "M0 60 90 0"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffce00",
    d: "m18 6.341 1.553 4.205L23 7.681l-.757 4.418 4.417-.758-2.864 3.448L28 16.341l-4.204 1.553 2.864 3.447-4.417-.757.757 4.418-3.447-2.865L18 26.341l-1.553-4.204L13 25.002l.757-4.418-4.417.757 2.864-3.447L8 16.341l4.204-1.552-2.864-3.448 4.417.758L13 7.681l3.447 2.865z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    stroke: "#003580",
    r: 5.5,
    cx: 18,
    cy: 16.341
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNa);
export default __webpack_public_path__ + "static/media/na.8be6ef90f288871ae17f4f936a361c8c.svg";
export { ForwardRef as ReactComponent };